import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=826fc6b6"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports